/* esm.sh - is-plain-obj@4.1.0 */
export * from "/*is-plain-obj@4.1.0/esnext/is-plain-obj.mjs";
export { default } from "/*is-plain-obj@4.1.0/esnext/is-plain-obj.mjs";
